module.exports = __webpack_public_path__ + "microCampaignHeader.svg?0302289c72407accf381be561f556373";